import React, { Component } from 'react';
import './InformationNoticePagination.css';
import axios from "axios";
import {RESOURCE_BASE_URL} from "../../../../../configuration";

class InformationNoticePagination extends Component {

    constructor(props) {
        super(props);
        this.state = {
            totalItemCount: 0,

        };
        this.getArticleCount = this.getArticleCount.bind(this);
        this.loadPageData = this.loadPageData.bind(this);
    }

    getArticleCount = () => {

        axios.get(RESOURCE_BASE_URL + 'api/article/count')
            .then((res) => {
                this.setState({
                    totalItemCount: res.data
                });
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });
    };

    loadPageData(i) {
        // this.props.getArticlesForPagination(((i*5)+1),5)
    }

    render(){
      /*  let btnCount=(this.state.totalItemCount/5)+1;
        let rows=[];
        for (let i=0;i<btnCount;i++){
            rows.push(<button className="page-button">
                {i+1}
            </button>)
        }*/

        return(
            <div className="info-notice-pagination">
                <button className="page-button">
               1
            </button>

                {/*{rows}*/}

            </div>
        );
    }

}
export default InformationNoticePagination;


// WEBPACK FOOTER //
// ./src/components/Site/HomeContent/InformationNotice/InformationNoticePagination/InformationNoticePagination.js